import React from 'react';

const ChartLegendBox = ({color}) => (
  <div className='legend-item_box' style={{
    backgroundColor: (color || 'lightgray'),
  }} />
);

export default ChartLegendBox;
